import { format } from 'date-fns';
import { th } from 'date-fns/locale';

function mongoIdToDt(_id) {
  const timestamp = _id.toString().substring(0, 8);
  const dt = new Date(parseInt(timestamp, 16) * 1000);
  return format(dt, 'dd/MM/yyyy HH:mm:ss', { th });
}

export default mongoIdToDt;
